import { render, staticRenderFns } from "./Whatsapps.vue?vue&type=template&id=73fcfbb5&scoped=true&"
import script from "./Whatsapps.vue?vue&type=script&lang=js&"
export * from "./Whatsapps.vue?vue&type=script&lang=js&"
import style0 from "./Whatsapps.vue?vue&type=style&index=0&id=73fcfbb5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73fcfbb5",
  null
  
)

export default component.exports